export default {
  fetchError: 'Error loading reservation',
  loading: 'Loading reservation...',
  errorTitle: 'Error',
  notFound: 'Reservation not found',
  reservationDetails: 'Reservation Details',
  resource: 'Resource',
  reserver: 'Reserved by',
  reservedFrom: 'Reserved from',
  reservedUntil: 'Reserved until',
  duration: 'Duration',
  createdAt: 'Created on',
  notes: 'Notes',
  days: 'days',
  hours: 'hours',
};
